import { Box, Grid, Skeleton } from '@mui/material'

interface Props {
  count?: number
}

export const BlogPostsGridSkeleton = ({ count = 6 }: Props) => {
  return (
    <Grid container spacing={2}>
      {Array.from({ length: count }).map((_, index) => (
        <Grid
          key={index}
          size={{
            xs: 12,
            sm: 6,
            md: 4,
            lg: 3,
            xl: 2.4,
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Skeleton
              variant="rectangular"
              width="100%"
              sx={{ borderRadius: 2, aspectRatio: '4/3', height: 'auto' }}
            />
            <Skeleton variant="text" sx={{ fontSize: '1.2rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '0.9rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '0.9rem' }} width="60%" />
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Skeleton variant="text" width={50} />
              <Skeleton variant="text" width={70} />
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  )
}
